import { IconCloudUpload, IconFileSpreadsheet, IconLoader2 } from '@tabler/icons-react'
import { format, parse } from 'date-fns'
import { useState } from 'react'
import { useSelector } from 'react-redux'
import { useEmployeeAPI, useEmployeeSEsUnderASMsAPI } from 'src/API/rest.employee'
import { useExecutiveWiseForcast } from 'src/API/rest.ExecutiveForecast'
import { useGetLatestCalendarDate } from 'src/API/rest.forecast_calender'
import { MonthCode } from 'src/API/rest.forecast_regionwise'
import { ButtonIconSquare } from 'src/components/buttons'
import { ProgressFullScreen } from 'src/components/progressLoading'
import { ErrorBoxStandard } from 'src/components/standard.errorbox'
import { FileInputDragDropStandard } from 'src/components/standard.fileDroper'
import { InputStandard } from 'src/components/standard.input'
import { SelectStandard } from 'src/components/standard.select'
import { TypographyH2 } from 'src/components/typography'
import { RootState } from 'src/redux/store'
import { toast } from 'src/shadcn/ui/use-toast'
import { RefMonthComponent } from './component.refMonth'
import { MultiselectStandard } from 'src/components/standard.multiselect'
import { ModalValidationError } from './component.validationErrorModal'
import { useForecastAPI } from 'src/API/rest.forecast'
import { useDownloadFile } from 'src/API/rest.downloadFile'


type MonthType = {
    month: string;
    value: string;
}

export default function ForcastExecutiveWise() {
    const [isOpen, setIsOpen] = useState(false)
    const currentDate = new Date();
    const [selectedDate, setSelectedDate] = useState(
        currentDate.toISOString().substring(0, 7) // Format: YYYY-MM
    );
    const [isDownloadingTemplate, setisDownloadingTemplate] = useState(false);
    const [employeeSelected, setemployeeSelected] = useState<number | null>(null)
    const [seletedFile, setSelectedFile] = useState<File | null>(null)
    const userData = useSelector((state: RootState) => state.user.employeeDetails)
    const [standardMonths, setStandardMonths] = useState<MonthType[]>([
        { month: 'LYM1', value: '' },
        { month: 'LYM2', value: '' },
        { month: 'LYM3', value: '' },
        { month: 'M-3', value: '' },
        { month: 'M-2', value: '' },
        { month: 'M-1', value: '' },
    ]);
    const [validationErrors, setValidationErrors] = useState<any | null>(
        null
    )

    const {
        isErrorlatestCalendarDate,
        isFetchedlatestCalendarDate,
        isFetchinglatestCalendarDate,
        isLoadinglatestCalendarDate,
        latestCalendarDate,
        refetchlatestCalendarDate
    } = useGetLatestCalendarDate({
        trigger: true,

    })


    const {
        downloadTemplateExecutivewiseforecast,
        isDownloadingTEmplateExcelforecast,
        isDownloadExcelForecastTemplateError,
        validateExecutivewiseforecastExel,
        isvalidateingExecutivewiseforecastExel,
        isvalidateExecutivewiseforecastExelError,
        validateProgress,
        uploadExecutivewiseforecastExel,
        isuploadingExecutivewiseforecastExel,
        uploadProgress
    } = useExecutiveWiseForcast({

    })

    const {
        ses: emloyees,
        isLoading: isLoadingEmployee,
        isFetching: isFetchingEmployee,
        isError: isEmployeeError,
    } = useEmployeeSEsUnderASMsAPI({
        asmId: userData.FM03_EmployeeID!,
    })


    const {
        forecastData,
        isFetchingForcastData,
        isErrorforcast,
        refetchForcastData
    } = useForecastAPI({
        FT02_Date: latestCalendarDate?.date || '',
        FT02_ForecastLevel: 'SEWise',
        FT02_M03_EmployeeIDSE: employeeSelected,
        FT02_M03_EmployeeIDASM: userData.FM03_EmployeeID,
        trigger: employeeSelected ? true : false
    })

    const {
        downoadFile
    } = useDownloadFile()


    const isAnyError = isEmployeeError || isErrorlatestCalendarDate
    const isAnyFething = isFetchinglatestCalendarDate || isFetchingEmployee
    const isLoading = isLoadingEmployee || isLoadinglatestCalendarDate




    if (isErrorlatestCalendarDate && !isFetchinglatestCalendarDate) {
        return (
            <div className=' grow flex flex-col items-center '>
                <ErrorBoxStandard
                    onRetry={refetchlatestCalendarDate}
                />
            </div>
        )
    }

    return (
        <div className=' grow  flex flex-col gap-1 overflow-auto items-center '>
            <ProgressFullScreen
                progress={validateProgress}
                show={isvalidateingExecutivewiseforecastExel}
                subTitle='Validating file...'
            />
            <ProgressFullScreen
                progress={uploadProgress}
                show={isuploadingExecutivewiseforecastExel}
                subTitle='uploading file...'
            />
            <RefMonthComponent
                forecastMonth={latestCalendarDate?.date || ''}
                isFetchingLatestForecastCalender={isFetchinglatestCalendarDate}
                setStandardMonths={setStandardMonths}
                standardMonths={standardMonths}
            />
            {/* NP style wise */}
            <div className=' grow flex flex-col  bg-white dark:bg-vstargray-900  rounded-md w-full text-center'>
                <div className=' grow flex flex-col  p-2 '>
                    <TypographyH2>Executive Wise</TypographyH2>
                    <div className=' flex gap-2 '>
                        {/* <InputStandard
                            title='Date'
                            placeholder='Date'
                            type='date'
                            disabled
                            value={latestCalendarDate?.date || ''}
                        /> */}
                        <InputStandard
                            title='Date'
                            type='month'
                            className='w-min'
                            value={latestCalendarDate?.date ? format(parse(latestCalendarDate?.date, 'yyyy-mm-dd', new Date()), 'yyyy-mm') : ''}
                            disabled
                        />
                        <MultiselectStandard
                            title='Employee'
                            singleSelect
                            placeholder='Select Employee'
                            options={emloyees?.length ? [
                                { label: 'Clear', value: 'clear' },
                                ...emloyees?.map(emp => ({ value: String(emp.FM03_EmployeeID), label: `${emp.FM03_EmployeeName} - (${emp.FM03_EmployeeCode})` }))] : []}
                            onValueChange={(value) => setemployeeSelected(Number(value.target.value))}
                            value={employeeSelected ? [String(employeeSelected)] : []}
                            name='employee'
                        />
                        <ModalValidationError
                            invalidData={validationErrors || null}
                            show={isOpen}
                            setShow={setIsOpen}
                        />
                    </div>
                    <div className=' grow flex flex-col justify-center items-center  w-min mx-auto mt-8'>
                        <div className='  text-center flex text-vstargray-800 dark:text-vstargray-100 py-2'>Download Template {isDownloadingTEmplateExcelforecast ? <IconLoader2 size={10} className=' inline animate-spin' /> : <span onClick={() => downloadTemplateExecutivewiseforecast({
                            date: latestCalendarDate?.date!,
                            LYM1: standardMonths[0].value,
                            LYM2: standardMonths[1].value,
                            LYM3: standardMonths[2].value,
                            'M3': standardMonths[3].value,
                            'M2': standardMonths[4].value,
                            'M1': standardMonths[5].value,
                            seId: employeeSelected ? [employeeSelected] : emloyees?.map(emp => emp.FM03_EmployeeID!) || [],
                            asmId: userData.FM03_EmployeeID!
                        })} className=' underline text-blue-500 cursor-pointer hover:text-blue-700'>here</span>}</div>
                        <FileInputDragDropStandard
                            disabled={!employeeSelected || !latestCalendarDate?.date ? true : false}
                            onDrop={async (file) => {
                                const fileName = file?.name?.split('.xlsx').slice(0, 1)?.join('.') || ''
                                const selectedEmployee = emloyees?.find(emp => emp.FM03_EmployeeID === employeeSelected)?.FM03_EmployeeName
                                if (fileName != selectedEmployee) {
                                    toast({
                                        description: 'File name not match with employee name',
                                        title: 'Error'
                                    })
                                    return
                                }
                                const response = await validateExecutivewiseforecastExel({
                                    file: file!,
                                    SEId: employeeSelected!,
                                })
                                if (response.success === false) {
                                    toast({
                                        description: response.message
                                    })
                                    setValidationErrors((response as any).errors || null)
                                    if ((response as any).errors)
                                        setIsOpen(true)
                                } else {
                                    setSelectedFile(file);
                                }
                            }}
                            file={seletedFile}
                            onClear={() => setSelectedFile(null)}
                            accept={{ 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'] }}
                        />
                    </div>
                    <ButtonIconSquare
                        disabled={seletedFile === null}
                        className=' mx-auto mb-5'
                        icon={isuploadingExecutivewiseforecastExel ? <IconLoader2 className='animate-spin' /> : <IconCloudUpload />}
                        onClick={async () => {



                            const response = await uploadExecutivewiseforecastExel({
                                date: latestCalendarDate?.date!,
                                file: seletedFile!,
                                SEId: employeeSelected!
                            })
                            if (response.success === false) {
                                toast({
                                    title: 'Error',
                                    description: response.message
                                })
                            } else {
                                toast({
                                    title: 'Success',
                                    description: response.message
                                })
                                setSelectedFile(null)
                                refetchForcastData()
                            }
                        }}
                        variant='secondary' text='Submit'
                    />
                    <div className=' fixed bottom-6 right-3'>
                        <ButtonIconSquare
                            disabled={ !latestCalendarDate?.date|| isFetchingForcastData}
                            icon={isFetchingForcastData ? <IconLoader2 className='animate-spin' /> : <IconFileSpreadsheet />}
                            onClick={async () => {
                                if (employeeSelected === null || !latestCalendarDate?.date) {
                                    toast({
                                        title: 'Error',
                                        description: 'Please select Executive'
                                    })
                                    return
                                }
                                const fileName = forecastData?.ForecastHeader?.[0]?.FT01_ForecastFileName
                                if (fileName) {
                                    try {
                                        await downoadFile(`${process.env.REACT_APP_BACKEND_URL_ONLY}/${fileName}`, 'stylewise_forecast.xlsx')
                                    } catch (error) {
                                        toast({
                                            title: 'Error',
                                            description: 'File not found'
                                        })
                                    }

                                } else {
                                    toast({
                                        title: 'Error',
                                        description: 'File not found'
                                    })
                                }

                            }}
                            variant='white' text='Download' />
                    </div>
                </div>
            </div>

        </div>
    )
}

